// This file was auto-generated by Fern from our API Definition.
export var DiscoveredTriggerEvent;
(function (DiscoveredTriggerEvent) {
    DiscoveredTriggerEvent.Type = {
        Trigger: "trigger",
    };
})(DiscoveredTriggerEvent || (DiscoveredTriggerEvent = {}));
